import React from 'react';
import './AboutImage.css'

const AboutImage = () => {
    return (
        <div className='cardcenter'>
            <div className="card">
                <div className="content">
                    <h2 className="title">Kim Sung Joon</h2>
                    <p className="copy">사용자가 사용하기 편리한 개발자가 되기 위하여 항상 노력하고 있습니다.</p>
                </div>
            </div>
        </div>
    );
};

export default AboutImage;